import axios from 'axios';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/parent/page_settings`;
  },

  dashboard() {
    return axios.get(`${this.baseUrl()}/dashboard`).catch(handleError);
  },
};
